module.exports = __webpack_public_path__ + "static/media/undo-alt.7aa17636.svg";